export function formatPhoneNumber(phone: string | undefined | null): string {
    if (phone == null) {
        return '';
    }

    let formattedNumber = '';
    const value = phone;
    const length = value.length;
    // Filter non numbers
    const regex = () => value.replace(/[^0-9\.]+/g, "");
    // Set area code with parenthesis around it
    const areaCode = () => `(${regex().slice(0, 3)})`;

    // Set formatting for first six digits
    const firstSix = () => `${areaCode()} ${regex().slice(3, 6)}`;

    // Dynamic trail as user types
    const trailer = (start: number) => `${regex().slice(start,
        regex().length)}`;
    if (length < 3) {
        // First 3 digits
        formattedNumber = regex();
    } else if (length === 4) {
        // After area code
        formattedNumber = `${areaCode()} ${trailer(3)}`;
    } else if (length === 5) {
        // When deleting digits inside parenthesis
        formattedNumber = `${areaCode().replace(")", "")}`;
    } else if (length > 5 && length < 9) {
        // Before dash
        formattedNumber = `${areaCode()} ${trailer(3)}`;
    } else if (length >= 10) {
        // After dash
        formattedNumber = `${firstSix()}-${trailer(6)}`;
    }

    return formattedNumber;
}

export function deepCopy<T>(source: T): T {
    return Array.isArray(source)
        ? source.map(item => deepCopy(item))
        : source instanceof Date
            ? new Date(source.getTime())
            : source && typeof source === 'object'
                ? Object.getOwnPropertyNames(source).reduce((o, prop) => {
                    o[prop] = deepCopy((source as any)[prop]);
                    Object.defineProperty(o, prop, Object.getOwnPropertyDescriptor(source, prop) as PropertyDescriptor);
                    return o;
                }, Object.create(Object.getPrototypeOf(source)))
                : source as T;
}

export function camelCase(str: string) {
    return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word: string, index: number) {
        return index === 0 ? word.toLowerCase() : word.toUpperCase();
    }).replace(/\s+/g, '');
}